import { MusicNotePlusIcon } from './MusicNotePlusIcon';

/**
 * author: GreenTurtwig
 * id ED5D1835-D69E-458A-9CCE-F1B81EB831D2
 * name music-note-plus
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-note-plus.svg
 * tags
 * - Audio 
 * - Music 
 */
export const MusicNoteAddIcon = MusicNotePlusIcon;
export default MusicNoteAddIcon